import React, { useContext } from "react";
import styled from "@emotion/styled";
import Context from "../ProductsProvider";
import PropTypes from "prop-types";

//style rules
import { Typography } from "../../../styles";

const ClearAllButton = ({ isDesktop }) => {
	const { data: { language, labelText},
		actions: { setActiveFilters, setParams, setLabel },
	} = useContext(Context);

	const clearButtonText = () => {
		if (language === "en") return "clear all";
		return "tout effacer";
	}

	const handleClearAllClick = () => {
		setActiveFilters([]);
		setParams(new URLSearchParams({pageNumber: 1, lang: language}));
		setLabel( labelText() );
	}
	
	return <Button isDesktop={isDesktop} type="button" onClick={handleClearAllClick}>{clearButtonText()}</Button>
}

export default ClearAllButton;

ClearAllButton.propTypes = {
	isDesktop: PropTypes.bool,
};

const Button = styled.button`
	all: unset;
	font-size: 15px;
	font-weight: ${Typography.fontWeight.medium};
	line-height: 1.9rem;
	text-decoration-line: underline;
	cursor: pointer;
	margin-left: ${props => !props.isDesktop ? "1rem" : "unset"};
`;